/// <reference types="google.maps" />
import { importLibrary, setOptions } from '@googlemaps/js-api-loader'

// Client-only: the loader writes a script tag, so this runs from effects and
// never during server rendering. The options are set once, by the first caller,
// because Google reads them when the first library loads.
let configured = false

/**
 * Loads a library of the Maps JavaScript API (decision D28: every map of the
 * platform is a Google map). The first call starts loading the API; the others
 * share it. Rejects when the API cannot be loaded, e.g. an invalid key or no
 * network: callers show their own fallback.
 */
export function loadGoogleMaps<Name extends keyof google.maps.ImportLibraryMap>(
	apiKey: string,
	library: Name,
	language: string
): Promise<google.maps.ImportLibraryMap[Name]> {
	if (!configured) {
		setOptions({ key: apiKey, v: 'weekly', language, region: 'IT' })
		configured = true
	}
	return importLibrary(library)
}
